<template>
  <div>
    <!-- <div v-if="isLoggedIn" class="dropdown">
    
    </div> -->
    <router-link to="/auth">
      <strava-button></strava-button>
    </router-link>
  </div>
</template>

<script>

import StravaButton from "@/components/Buttons/StravaButton";

export default {
  components: {
    StravaButton,
  },
  computed: {
    //...mapGetters(["isLoggedIn", "athlete"]),
  },
  methods: {
    //...mapMutations(["logout"]),

    logoutAndRedirect() {
      this.logout();
      this.$router.push("/").catch((err) => {console.log(err)});
    },
  },
};
</script>